export class CostProductFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<CostProduct>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<CostProduct>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostProductFilters.attributeTypeMap;
    }
    constructor() {
    }
}
